<template>
    <div class="library-search-input">
        <SearchIcon />
        <input type="search"
               v-model="term"
               @focus="focused = true"
               @blur="focused = false"
               placeholder="Search..."
               autocomplete="off"
               autocapitalize="off"
               spellcheck="false">

        <div v-if="term.length > 0" @click="clear" class="cursor-pointer hover:opacity-60">
<!--            <close-icon />-->
        </div>
    </div>
</template>

<script>
import { assign, debounce } from 'lodash-es';

export default {
    components: {
        SearchIcon: () => import('../Icons/SearchIcon.vue'),
        CloseIcon: () => import('../Icons/CloseIcon.vue')
    },
    props: {
        value: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            term: this.value || '',
            focused: false,
        };
    },

    watch: {
        value() {
            this.term = this.value;
        },

        term(value, old) {
            this.mutateQuery();
        },
    },
    methods: {
        mutateQuery: debounce(function () {
            let query = assign({}, this.$route.query, {
                'filter[search]': this.term,
            });

            if (query.page && query.page > 1) {
                delete query.page;
            }

            if (0 === this.term.length) {
                delete query['filter[search]'];
            }

            this.$router.push(assign({}, this.$route, {query}));
        }, 150),
        clear(){
            this.term = '';
        }
    },
};
</script>